module.exports = "/_next/static/images/e994fb027eec52089d0e18f00ef9c469-google-store.svg";